import axios, { AxiosResponse } from 'axios';
import LRU from 'lru-cache';
import https from 'https';

const isServer = typeof process !== 'undefined' && process.server;

/* one shared cache per Node-process */
const treeCache: LRU<string, AxiosResponse> | null = isServer
  ? global.__TREE_CACHE__ ||
    (global.__TREE_CACHE__ = new LRU<string, AxiosResponse>({
      max: 1,
      maxAge: 1000 * 60 * 10, // 10 min
    }))
  : null;

const httpsAgent = isServer ? new https.Agent({ rejectUnauthorized: false }) : undefined;

const apiBase = process.env.VUE_APP_DOC_API_URL ?? '';
const apiRegion = process.env.VUE_APP_SITE_API_URL ?? '';
const langRu = [process.env.VUE_APP_LANG, process.env.VUE_APP_PROD_LANG].includes('ru');
const isKit = process.env.VUE_APP_INSTANCE === 'kit';
const needRu = langRu && isKit;

export async function fetchRegion(): Promise<AxiosResponse> {
  return await axios.get(apiRegion + 'getLoc', { httpsAgent });
}

export async function fetchPosts(url: string): Promise<AxiosResponse> {
  if (isServer && url === 'getTree') {
    const cached = treeCache.get(url);
    if (cached) {
      return cached;
    }
  }

  const resp = await axios.get(apiBase + url, {
    httpsAgent,
    ...(needRu ? { params: { lang: 'ru' } } : {}),
  });

  if (isServer && url === 'getTree' && resp.status === 200) {
    treeCache.set(url, resp);
  }

  return resp;
}

export function fetchCancelableRequest(url: string, params?: any) {
  return axios.get(apiBase + url, params).catch((error) => error);
}
